module.exports = __webpack_public_path__ + "6b68c197f1cbfdc78889170b0f847816.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/equileap-stamp.png
// module id = 1390
// module chunks = 0